import './App.css';

import React, { useEffect } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

import Header from './components/Header';
import {
  CommercialPage,
  CommercialWithApplicationIdPage,
  CompletePage,
  ErrorPage,
  NotFound,
  QuotePage
} from './pages';
import LobShell from './pages/LobShell/LobShell';
import QuoteExpired from './pages/QuoteExpired/QuoteExpired';
import getEnv from './utils/getEnv';
import ContextProvider from './utils/store';

const App: React.FC = () => {
  useEffect(() => {
    // add hubspot tracking script
    const script = document.createElement('script');
    const hubspotAccount = getEnv().REACT_APP_HUBSPOT_ACCOUNT;
    script.src = `//js.hs-scripts.com/${hubspotAccount}.js`;
    script.async = true;
    script.defer = true;
    script.type = 'text/javascript';
    document.body.appendChild(script);
  }, []);

  return (
    <ContextProvider>
      <BrowserRouter basename={process.env.REACT_APP_PUBLIC_URL}>
        <Header />
        <Switch>
          <Route exact path="/" component={CommercialPage} />
          <Route
            exact
            path="/commercial"
            render={(props) => {
              const { search } = props.location;
              return <Redirect to={{ pathname: '/', search }} />;
            }}
          />
          <Route
            exact
            path="/application"
            render={(props) => {
              const { search } = props.location;
              return <Redirect to={{ pathname: '/', search }} />;
            }}
          />
          <Route exact path="/error" component={ErrorPage} />
          {/*
            :applicationGroupId is the canonical new-URL param. For
            back-compat, the backend resolver also accepts a legacy
            applicationId here (same /quote/:id shape), so old production
            links of the form /quote/:applicationId continue to work.

            Listed before the catch-all /:lobType/:applicationId so a 24-hex
            applicationGroupId doesn't get swallowed by the lobType route.
          */}
          <Route
            exact
            path="/quote/:applicationGroupId"
            component={QuotePage}
          />
          <Route
            exact
            path="/:lobType(GL|EO)/:applicationId([a-fA-F0-9]{24})"
            component={LobShell}
          />
          <Route
            exact
            path="/:applicationId([a-fA-F0-9]{24})"
            component={CommercialWithApplicationIdPage}
          />
          <Route exact path="/complete" component={CompletePage} />
          <Route exact path="/quote-expired" component={QuoteExpired} />
          <Route path="*" component={NotFound} />
        </Switch>
      </BrowserRouter>
    </ContextProvider>
  );
};

export default App;
